/* eslint-disable complexity */
import _ from 'lodash';
import { Alert, Button } from 'react-bootstrap';
import CustomToggle from './CustomToggle';

/**
 * Navigation displays the control group buttons for navigation between steps
 */
const Navigation = (props) => {
  const {
    handleLogout, handleOnFinish, last, index, isStepValid, handleActiveStep, results,
  } = props;

  const error = _.get(results, 'error');

  return (
    <div className="mt-8 d-flex gap-4 mb-none">
      {error && (
        <Alert variant="danger">
          <Alert.Heading>{_.startCase(error.name) || 'Error'}</Alert.Heading>
          {_.get(error, 'message') || error }
        </Alert>
      )}
      {!last
          && (
          <CustomToggle
            variant="primary"
            eventKey={`${index + 1}`}
            isValid={isStepValid}
            handleActiveStep={handleActiveStep}
          >
            Next
          </CustomToggle>
          )}
      {' '}
      {last
          && (
          <Button variant="primary" size="sm" disabled={!isStepValid} onClick={handleOnFinish}>
            Finish
          </Button>
          )}
      {' '}
      {index > 0
          && (
          <CustomToggle
            variant="outline-primary"
            eventKey={`${index - 1}`}
            isValid="true"
            handleActiveStep={handleActiveStep}
          >
            Previous
          </CustomToggle>
          )}
      <Button variant="link" onClick={handleLogout}>
        Cancel
      </Button>
    </div>
  );
};

export default Navigation;
